import ConstituentExportFieldName from '@/constants/constituents/ConstituentExportFieldName';
import translate from '@/lib/intl/translate';
import type ConstituentExportField from '@/types/api/ConstituentExportField';
import CsvExportBasicProfileFields from './CsvExportBasicProfileFields';
import CsvExportHiddenFields from './CsvExportHiddenFields';
import CsvExportHouseholdInformationFields from './CsvExportHouseholdInformationFields';

const CsvExportDefaultFields: Omit<ConstituentExportField, 'value'>[] = [
  ...CsvExportBasicProfileFields,
  ...CsvExportHouseholdInformationFields,
  ...CsvExportHiddenFields,
  {
    fieldLabel: translate('CONSTITUENT_INCLUDE_ALL_CUSTOM_FIELDS'),
    fieldName: ConstituentExportFieldName.CUSTOM_FIELDS,
  },
];

export default CsvExportDefaultFields;
